import { render, staticRenderFns } from "./AddPlantInput.vue?vue&type=template&id=6bf9d5fa&"
import script from "./AddPlantInput.vue?vue&type=script&lang=js&"
export * from "./AddPlantInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports